const scrollToElement = require("scroll-to-element");

// Full list of fos from learning model [69903,909,1007,19901,2,3,4,5,60301,109,10,91901,803,1,7]
export const getShortId = (id) => {
  switch (id) {
    // Handle lower fos IDs
    case "109": // Biological Science
    case "19901": // Medical Science
      return "1";
    case "60301": // General Nursing
    case "69903": // Human Movement
      return "6";
    case "803": // Business Management
      return "8";
    case "909": // Law
      return "9";
    case "91901": // Economics
      return "9";
    case "1007": // Communication and Media Studies
      return "10";

    // defaults
    case "1":
    case "2":
    case "3":
    case "4":
    case "5":
    case "7":
    case "10":
    default:
      return id;
  }
};

export const scrollToTop = () => {
  scrollToElement("#course-compass-banner", {
    offset: 0,
    duration: 200,
  });
};

export const parsePositiveInteger = (value) =>
  Number.isInteger(parseInt(value)) && parseInt(value) > 0 ? value : null;

const MIN_SUBJECTS = 4;
export const MAX_SUBJECTS = 10;
export const validSubjectNo = (subjects) => {
  return subjects.length >= MIN_SUBJECTS && subjects.length <= MAX_SUBJECTS;
};

export const MIN_ATAR = 30;
const MAX_ATAR = 99.95;
export const validAtar = (atar) => {
  return atar >= MIN_ATAR && atar <= MAX_ATAR;
};

const MIN_SUBJECT_MARK = 0;
const MAX_SUBJECT_MARK = 100;
export const validHscMarks = (knowAtar, selectedSubjects, hscMarks) => {
  if (!knowAtar) {
    return true;
  }
  let valid = true;
  selectedSubjects.forEach((sub) => {
    const { subject_id } = sub;
    const mark = hscMarks[subject_id];
    if (!mark || mark < MIN_SUBJECT_MARK || mark > MAX_SUBJECT_MARK) {
      valid = false;
    }
  });
  return valid;
};

export const sortSubjects = (listOfSubjects) =>
  listOfSubjects.sort((a, b) => (a.subject_desc < b.subject_desc ? -1 : 1));
